import type {ListViewSectionFilterLinks} from '@github-ui/list-view/ListViewSectionFilterLink'
import {Box} from '@primer/styled-react'
import {type FC, Fragment} from 'react'

import {ActionListLoading} from './ActionListLoading'
import styles from './ListLoading.module.css'

export type ListLoadingProps = {
  pageSize: number
  showBorder?: boolean
  headerTitle?: string
  sectionFilters?: ListViewSectionFilterLinks
  isCompactRows?: boolean
}

const ListLoading: FC<ListLoadingProps> = ({
  pageSize,
  showBorder = true,
  headerTitle,
  sectionFilters,
  isCompactRows,
}) => {
  return (
    <Box sx={showBorder ? {border: '1px solid', borderColor: 'border.muted', borderRadius: 2} : {}}>
      {showBorder && (
        <div className={styles.ListLoadingHeader}>
          {headerTitle}
          {sectionFilters?.map((sectionFilterLink, i) => (
            // eslint-disable-next-line @eslint-react/no-array-index-key
            <Fragment key={`section-filter-link-${i}`}>{sectionFilterLink}</Fragment>
          ))}
        </div>
      )}
      <ActionListLoading numberOfRows={pageSize} isCompact={isCompactRows} />
    </Box>
  )
}

export default ListLoading
